import { FC } from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { fontWeights } from '../../theme/tokens';

// Assembly takes time: with ten pages it is seconds, to the point that
// the backend's functional tests measure that time. It is shared by step
// 3 of the wizard and "Régénérer le PDF" of the edit.

type Props = {
  pageCount: number;
};

const AssemblingProgress: FC<Props> = ({ pageCount }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, py: 4 }}
  >
    <Typography sx={{ fontWeight: fontWeights.medium }}>
      Assemblage du document en cours…
    </Typography>
    <LinearProgress
      color="secondary"
      sx={{ height: 6, borderRadius: 3, backgroundColor: 'rgba(255, 255, 255, 0.24)' }}
    />
    <Typography sx={{ fontSize: '0.8125rem', opacity: 0.85 }}>
      {pageCount} page{pageCount > 1 ? 's' : ''} à assembler en un seul PDF.
      Cela peut prendre quelques secondes.
    </Typography>
  </Box>
);

export default AssemblingProgress;
